import { useIntl } from "react-intl";

/**
 * The "unpii.me" wordmark with "pii" in the accent color - marketing-brand
 * usage only (owner, 2026-09-15): the home page's h1 and the header's logo
 * text. Never in running body copy, and never in the accessible name - the
 * two `app.name` aria-labels in header.tsx and the JSON-LD `name` field in
 * home.tsx keep calling `intl.formatMessage({ id: "app.name" })` directly
 * and stay the plain string.
 *
 * Splits the RESOLVED string on "pii" at render time rather than editing the
 * `app.name` message itself, because that same key also feeds those plain
 * aria-labels and the JSON-LD name - changing its value there would put
 * markup or ICU rich-text tags into contexts that must stay plain text.
 * de.json and en.json currently agree ("unpii.me"), but if a future locale's
 * name ever drops "pii", this falls back to the unstyled string instead of
 * throwing.
 *
 * Always one wrapping element: the header's logo link is `flex gap-2`, and
 * loose text nodes beside the accent span would each become a flex item with
 * the gap inside the word ("un pii .me").
 */
export function BrandWordmark() {
  const intl = useIntl();
  const name = intl.formatMessage({ id: "app.name" });
  const idx = name.indexOf("pii");
  if (idx === -1) return <span>{name}</span>;
  return (
    <span>
      {name.slice(0, idx)}
      <span className="text-accent">{name.slice(idx, idx + 3)}</span>
      {name.slice(idx + 3)}
    </span>
  );
}
